import React from "react";
export var isHTMLElement = function(node) {
    if (typeof node !== 'undefined' && node !== null) {
        return node.hasOwnProperty('offsetHeight');
    }
    return false;
};
